import { motion } from "framer-motion";
import React, { useEffect } from "react";
import ProjectsList from "../components/ProjectsList";
import pageAnimation from "../pageAnimation";
import { frameAnim } from "../pageAnimation";
import styled from "styled-components";

const ProjectPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <motion.div
      variants={pageAnimation}
      initial="before"
      animate="after"
      exit="exit"
      style={{ overflowX: "hidden" }}
    >
      <Frame1 variants={frameAnim} />
      <Frame2 variants={frameAnim} />
      <Frame4 variants={frameAnim} />

      <Frame3 variants={frameAnim} />
      <ProjectsList />
    </motion.div>
  );
};
const Frame1 = styled(motion.div)`
  background-color: darkblue;
  z-index: 10;
  position: absolute;
  top: 10%;
  left: 0;
  width: 120rem;
  height: 100vh;
`;
const Frame2 = styled(Frame1)`
  background-color: blue;
`;
const Frame3 = styled(Frame1)`
  background-color: lightblue;
`;
const Frame4 = styled(Frame1)`
  background-color: blueviolet;
`;
export default ProjectPage;
